import { FunctionComponent } from 'react';
import ContactSupportPopUpBase from '../ContactSupportPopUpBase/ContactSupportPopUpBase';
import { CLIENT_SUPPORT_CONTENT } from '../../../data/clientSupport';

interface ContactSupportPopUpKarlaProps {
  active: boolean;
  setActive(state: boolean): void;
}

const ContactSupportPopUpKarla: FunctionComponent<ContactSupportPopUpKarlaProps> = ({ active, setActive }) => {
  return (
    <ContactSupportPopUpBase
      active={active}
      setActive={setActive}
      image={CLIENT_SUPPORT_CONTENT.ava_2}
      email={CLIENT_SUPPORT_CONTENT.email}
      name={CLIENT_SUPPORT_CONTENT.name}
      positionText={CLIENT_SUPPORT_CONTENT.position}
      telNumber={CLIENT_SUPPORT_CONTENT.tel}
    />
  );
};

export default ContactSupportPopUpKarla;
